import { render, staticRenderFns } from "./GroupsForSurvey.vue?vue&type=template&id=5a1ff2f6"
import script from "./GroupsForSurvey.vue?vue&type=script&lang=ts"
export * from "./GroupsForSurvey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports